import { createI18n } from 'vue-i18n'

const messages = {
  en: {
    index: {
      past: 'Past',
      future: 'Current',
      apply: 'Apply',
      week: 'This week',
      day: 'Today',
      weekend: 'Weekend',
      calendar: 'Calendar',
      filters: 'Filters',
      reset: 'Reset filters',
    },
    apply: {
      select: 'Select',
      category: 'Pick a category',
      subcategory: 'Pick a subcategory',
      type: 'Pick the contruction type',
      submit: 'Continue',
    },
    form: {
      file: { upload: 'Upload file', reupload: 'Upload file again' },
      multifile: {
        upload: 'Upload files',
        reupload: 'Upload different files',
      },
      serverError:
        'Server is currently busy. Please try again in a few minutes.',
      submit: 'Send application',
    },
  },
  ro: {
    index: {
      past: 'Trecute',
      future: 'Actuale',
      apply: 'Aplică',
      week: 'Săptămâna asta',
      day: 'Azi',
      weekend: 'Weekend',
      calendar: 'Calendar',
      filters: 'Filtre',
      reset: 'Resetează criteriile',
    },
    apply: {
      select: 'Selectează',
      category: 'Alege categoria de concurs',
      subcategory: 'Alege subcategoria',
      type: 'Alege tipul construcției',
      submit: 'Începe o aplicație',
    },
    form: {
      file: { upload: 'Încarcă fișierul', reupload: 'Reîncarcă fișierul' },
      multifile: {
        upload: 'Încarcă fișierele',
        reupload: 'Reîncarcă fișierele',
      },
      serverError:
        'Momentan serverul este ocupat. Încercați din nou în câteva minute.',
      submit: 'Trimite aplicația',
    },
  },
}

export default createI18n({
  locale: document.documentElement.lang,
  fallbackLocale: 'ro',
  legacy: false,
  messages,
})
